import { render, staticRenderFns } from "./msg_list_dialog.vue?vue&type=template&id=2aaee17a&scoped=true"
import script from "./msg_list_dialog.vue?vue&type=script&lang=js"
export * from "./msg_list_dialog.vue?vue&type=script&lang=js"
import style0 from "./msg_list_dialog.vue?vue&type=style&index=0&id=2aaee17a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aaee17a",
  null
  
)

export default component.exports